module.exports = __webpack_public_path__ + "static/media/clark.4a6e87f6.png";